import React from 'react';
import Lottie from 'react-lottie';
import { useQuery } from '@tanstack/react-query';
import GoodToGo from './good-to-go';
import PoweredByEmotive from './powered-by-emotive';
import ShopPayLogo from './shop-pay-logo';
import animationData from './shop-pay-lottie-file.json';
import { useLocation } from 'react-router-dom';

export default function ShopPayRedirect() {
  const { search } = useLocation();
  const queryKey = 'shop-pay-redirect';
  const { isLoading, isSuccess, isError } = useQuery(
    queryKey,
    async () => {
      const response = await fetch(
        `${process.env.REACT_APP_SMAUG_BASE_URI}/shopify/pay/redirect_uri${search}`
      );
      if (!response.ok) {
        throw Error(JSON.stringify(await response.json()))
      }
      return await response.json();
    }
  );

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1em',
        paddingBottom: '2em'
      }}
    >
      <div style={{ flexGrow: 1 }} />
      {isError && (
        <>
          <ShopPayLogo />
          <div style={{ textAlign: 'center', width: 327 }}>
            Oops, looks like something went wrong! Please try again.
          </div>
        </>
      )}
      {isSuccess && (
        <>
          <ShopPayLogo />
          <GoodToGo />
          <div style={{ textAlign: 'center', width: 327 }}>
            You should receive a text message shortly to continue checking out
            via texts
          </div>
        </>
      )}
      {!isError && isLoading && <Lottie options={{ animationData }} height={190} />}
      <div style={{ flexGrow: 1 }} />
      <PoweredByEmotive />
    </div>
  );
}
